import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detail-actes-bareme',
  templateUrl: './detail-actes-bareme.component.html',
  styleUrls: ['./detail-actes-bareme.component.scss']
})
export class DetailActesBaremeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
